import {Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'admin-header',
  templateUrl: './admin-header.component.html',
  styleUrls: ['../../../pages/admin/startbootstrap-sb-admin-gh-pages/src/scss/styles.scss', './admin-header.component.scss']
})

export class AdminHeaderComponent {

  @Input() envName: string | undefined;
  @Output() toggleSidebarEvent = new EventEmitter();

  toggleSidebar(): void {
    this.toggleSidebarEvent.emit();
  }
}